import { useState } from "react";
import { ColumnsType } from "antd/es/table";
import { RotateCw } from "lucide-react";
import { Avatar, Button, Col, Table, Typography, Space, Tag } from "antd";
import { notify } from "@/shared/utils/notify";
import { useParams } from "react-router-dom";

import { OrderDetail } from "../../../../redux/@types";
import { PATH_S3_BUCKET } from "../../../../shared/utils/constants";
import { decimal } from "../../../../shared/utils/Helper";
import { ordersService } from "../../../../shared/services";
import useAppDispatch from "../../../../redux/hooks/useAppDispatch";
import { setOrdersForUpdate } from "../../../../redux";

interface Props {
  data: OrderDetail[];
}

const { Text } = Typography;

export const InfoOrderDetails = ({ data }: Props) => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const getRefreshSingleOrder = async () => {
    if (isLoading) return;
    setIsLoading(true);
    return await ordersService
      .get(Number(id))
      .then((res) => {
        setIsLoading(false);
        return dispatch(setOrdersForUpdate(res));
      })
      .catch((err: any) => {
        console.log(err);
        setIsLoading(false);
        return notify.error(err.message);
      });
  };
  const columns: ColumnsType<OrderDetail> = [
    {
      title: "Producto",
      key: "product",
      render: (_, item) => (
        <Space size={12}>
          <Avatar
            size={56}
            shape="square"
            src={`${PATH_S3_BUCKET}/${item.product_main_image}`}
            style={{ borderRadius: 8 }}
          />
          <div>
            <Text strong style={{ display: "block", fontSize: 13 }}>
              {item.product_name}
            </Text>
            <Text type="secondary" style={{ fontSize: 12 }}>
              ID: {item.product_id}
            </Text>
            {item.product_integration_id && (
              <Text type="secondary" style={{ fontSize: 11, display: "block" }}>
                EAN: {item.product_integration_id}
              </Text>
            )}
          </div>
        </Space>
      ),
    },
    {
      title: "Precio",
      dataIndex: "total_price_tax_incl",
      key: "total_price_tax_incl",
      render: (_, item) => (
        <Text strong style={{ fontSize: 14, color: "#E95735" }}>
          ${decimal(item.total_price_tax_incl)}
        </Text>
      ),
    },
    {
      title: "Cantidad",
      key: "quantity",
      render: (_, item) => (
        <Space direction="vertical" size={4}>
          <div>
            <Text type="secondary" style={{ fontSize: 11 }}>Comprada: </Text>
            <Tag color="blue" style={{ fontSize: 12, borderRadius: 6 }}>
              {item.quantity}
            </Tag>
          </div>
          <div>
            <Text type="secondary" style={{ fontSize: 11 }}>Enviada: </Text>
            <Tag color="green" style={{ fontSize: 12, borderRadius: 6 }}>
              {item.sent}
            </Tag>
          </div>
          {item.quantity - item.sent > 0 && (
            <div>
              <Text type="secondary" style={{ fontSize: 11 }}>Restante: </Text>
              <Tag color="orange" style={{ fontSize: 12, borderRadius: 6 }}>
                {item.quantity - item.sent}
              </Tag>
            </div>
          )}
        </Space>
      ),
    },
  ];

  return (
    <Col
      span={24}
      style={{
        width: "100%",
        display: "flex",
        margin: "auto",
        justifyContent: "flex-start",
        alignItems: "flex-end",
        flexDirection: "column",
      }}
    >
      <Button
        style={{ 
          marginBottom: "12px",
          borderRadius: 20,
          height: 36,
          paddingLeft: 20,
          paddingRight: 20,
          fontWeight: 500,
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          display: "flex",
          alignItems: "center",
          gap: 6
        }}
        type="primary"
        onClick={getRefreshSingleOrder}
        disabled={isLoading}
        loading={isLoading}
        icon={<RotateCw size={16} />}
      >
        Actualizar
      </Button>
      <Table
        style={{ 
          width: "100%",
          borderRadius: 8,
          overflow: "hidden"
        }}
        pagination={false}
        bordered
        columns={columns}
        dataSource={data}
      />
    </Col>
  );
};
